<app-loading *ngIf="loading"></app-loading>
<div class="container">
  <app-title-content [title]="title"></app-title-content>

  <div class="section">
    <ul class="nav nav-tabs mt-4">
      <li class="nav-item">
        <button
          (click)="changeTab(0)"
          class="nav-link"
          [ngClass]="{ active: tab === 0 }"
        >
          E-coupon
        </button>
      </li>
      <li class="nav-item">
        <button
          (click)="changeTab(1)"
          class="nav-link"
          [ngClass]="{ active: tab === 1 }"
        >
          เควส
        </button>
      </li>
      <!-- <li class="nav-item">
        <button
          (click)="changeTab(2)"
          class="nav-link"
          [ngClass]="{ active: tab === 2 }"
        >
          แคมเปญ
        </button>
      </li> -->
    </ul>

    <!-- E-coupon -->
    <app-info-e-coupon *ngIf="!showResult && tab === 0" style="width: 100%;" (dataChange)="updateECoupon($event)" (disable)="disabledButton($event,0)"></app-info-e-coupon>
    <!-- quest -->
    <app-info-quest *ngIf="!showResult && tab === 1" style="width: 100%;" (dataChange)="updateQuest($event)" (disable)="disabledButton($event,1)"></app-info-quest>
    <!-- campaign -->
    <app-info-campaign *ngIf="!showResult && tab === 2" style="width: 100%;" (dataChange)="updateCampaign($event)" (disable)="disabledButton($event,2)"></app-info-campaign>

    <!-- E-coupon -->
    <div *ngIf="showResult && tab === 0" class="container-form">
      <div class="card py-3">
        <span class="title-card">{{ title }}</span>
        <div class="row body-card">
          <div class="col-lg-6 col-md-12 item">
            <span>Customer ID</span>
            <span>{{ customer?.id ?? "-" }}</span>
          </div>
          <div class="col-lg-6 col-md-12 item">
            <span>ชื่อลูกค้า</span>
            <span>{{ customer?.fullname ?? "-" }}</span>
          </div>
        </div>
        <div class="row body-card">
          <div class="col-lg-6 col-md-12 item">
            <span>อีเมล</span>
            <span>{{ customer?.email ?? "-" }}</span>
          </div>
          <div class="col-lg-6 col-md-12 item">
            <span>ชื่อ Line</span>
            <span>{{ customer?.lineName ?? "-" }}</span>
          </div>
        </div>
        <div class="content-card">
          <span class="title-card">ข้อมูล E-coupon</span>
          <div class="row body-card py-3">
            <div class="col-lg-6 col-md-12 item">
              <span>ชื่อ</span>
              <span>{{ ecoupon?.name ?? "-" }}</span>
            </div>
            <div class="col-lg-6 col-md-12 item">
              <span>รายละเอียด</span>
              <span>{{ (ecoupon?.details ?? "") == "" ? "-" : ecoupon?.details }}</span>
            </div>
          </div>
          <div class="row body-card pb-2">
            <img
              [src]="ecoupon.coverUrl"
              style="max-width: 624px; max-height: 351px"
              alt=""
            />
          </div>
          <div *ngIf="ecoupon?.type == 'GIFT'">
            <span class="title-card">เงื่อนไขการใช้งาน</span>
            <div *ngIf="ecoupon?.conditions[0]?.conditionType == 'DATE_RANGE_CONDITION'">
              <div class="row body-card py-3">
                <div class="col-lg-6 col-md-12 item">
                  <span>ประเภทเงื่อนไข</span>
                  <span>{{displayConditionType(ecoupon?.conditions[0]?.conditionType)}}</span>
                </div>
                <div class="col-lg-6 col-md-12 item">
                  <span>ช่วงเวลา</span>
                  <span>{{(ecoupon?.conditions[0]?.startAt | date:'dd/MM/yyyy') ?? ''}} - {{(ecoupon?.conditions[0]?.endAt | date:'dd/MM/yyyy') ?? ''}}</span>
                </div>
              </div>
              <div class="row body-card">
                <div class="col-lg-6 col-md-12 item">
                  <span>ปรเภทการใช้</span>
                  <span>-</span>
                </div>
                <div class="col-lg-6 col-md-12 item">
                  <span>สถานะ</span>
                  <span>{{ecoupon.status ?? '-'}}</span>
                </div>
              </div>
            </div>
            <div *ngIf="ecoupon?.conditions[0]?.conditionType != 'DATE_RANGE_CONDITION'">
              <div class="row body-card pb-3">
                <div class="col-lg-6 col-md-12 item">
                  <span>ประเภทเงื่อนไข</span>
                  <span>{{displayConditionType(ecoupon?.conditions[0]?.conditionType)}}</span>
                </div>
                <div class="col-lg-6 col-md-12 item">
                  <span>ระยะเวลา</span>
                  <span>{{displayPeriodTime(ecoupon?.conditions[0]?.periodTime)}}</span>
                </div>
              </div>
              <div *ngIf="ecoupon?.conditions[0]?.periodTime == 'MORE_THAN_NOT_OVER'" class="row body-card pb-3">
                <div class="col-lg-6 col-md-12 item">
                  <span>ช่วงเวลา</span>
                  <span>More than</span>
                </div>
              </div>
              <div class="row body-card pb-3">
                <div class="col-lg-6 col-md-12 item">
                  <span>จำนวน (ตัวเลข)</span>
                  <span>{{ecoupon?.conditions[0]?.times ?? '-'}}</span>
                </div>
                <div class="col-lg-6 col-md-12 item">
                  <span>ประเภทวัน</span>
                  <span>{{displayPeriodType(ecoupon?.conditions[0]?.periodType)}}</span>
                </div>
              </div>
              <div *ngIf="ecoupon?.conditions[0]?.periodTime == 'MORE_THAN_NOT_OVER'">
                <div class="row body-card pb-3">
                  <div class="col-lg-6 col-md-12 item">
                    <span>ช่วงเวลา</span>
                    <span>Not Over</span>
                  </div>
                </div>
                <div class="row body-card pb-3">
                  <div class="col-lg-6 col-md-12 item">
                    <span>จำนวน (ตัวเลข)</span>
                    <span>{{ecoupon?.conditions[0]?.notOverTimes ?? '-'}}</span>
                  </div>
                  <div class="col-lg-6 col-md-12 item">
                    <span>ประเภทวัน</span>
                    <span>{{displayPeriodType(ecoupon?.conditions[0]?.notOverPeriodType)}}</span>
                  </div>
                </div>
              </div>
              <div class="row body-card pb-3">
                <div class="col-lg-6 col-md-12 item">
                  <span>ปรเภทการใช้</span>
                  <span>{{getNameUseageType(ecoupon?.conditions[0]?.useType)}}</span>
                </div>
                <div class="col-lg-6 col-md-12 item">
                  <span>สถานะ</span>
                  <span>{{ecoupon.status ?? '-'}}</span>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="ecoupon?.type == 'EXCHANGE'">
            <span class="title-card pb-3">เงื่อนไขการใช้งาน</span>
            <div class="row body-card pb-3">
              <div class="col-lg-6 col-md-12 item">
                <span>เงื่อนไข</span>
                <span>{{ ecoupon?.conditionDetails ?? "-" }}</span>
              </div>
              <div class="col-lg-6 col-md-12 item">
                <span>คะแนนที่ใช้แลก</span>
                <span>{{ ecoupon?.claimPoints ?? '-'}}</span>
              </div>
            </div>
            <div class="row body-card pb-3">
              <div class="col-lg-6 col-md-12 item">
                <span>เลือกช่วงเวลาที่ใช้</span>
                <span>{{(ecoupon?.startAt | date:'dd/MM/yyyy') ?? ''}} - {{(ecoupon?.endAt | date:'dd/MM/yyyy') ?? ''}}</span>
              </div>
              <div class="col-lg-6 col-md-12 item">
                <span>สถานะที่ใช้</span>
                <span>{{ecoupon.status ?? '-'}}</span>
              </div>
            </div>
            <div class="row body-card pb-3">
              <div class="col-lg-6 col-md-12 item">
                <span>เลือกช่วงเวลาที่ redeem</span>
                <span>{{(ecoupon?.redeemStartAt | date:'dd/MM/yyyy') ?? ''}} - {{(ecoupon?.redeemEndAt | date:'dd/MM/yyyy') ?? ''}}</span>
              </div>
              <div class="col-lg-6 col-md-12 item">
                <span>สถานะที่ redeem</span>
                <span>{{ecoupon.status ?? '-'}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- quest -->
    <div *ngIf="showResult && tab === 1" class="container-form">
      <div class="card py-3">
        <span class="title-card">{{ title }}</span>
        <div class="row body-card">
          <div class="col-lg-6 col-md-12 item">
            <span>Customer ID</span>
            <span>{{ customer?.id ?? "-" }}</span>
          </div>
          <div class="col-lg-6 col-md-12 item">
            <span>ชื่อลูกค้า</span>
            <span>{{ customer?.fullname ?? "-" }}</span>
          </div>
        </div>
        <div class="row body-card">
          <div class="col-lg-6 col-md-12 item">
            <span>อีเมล</span>
            <span>{{ customer?.email ?? "-" }}</span>
          </div>
          <div class="col-lg-6 col-md-12 item">
            <span>ชื่อ Line</span>
            <span>{{ customer?.lineName ?? "-" }}</span>
          </div>
        </div>
        <div class="content-card">
          <span class="title-blue">ข้อมูลเควส</span>
          <span class="title-black">รูปภาพ</span>
          <div class="body-image">
            <img
              [src]="quest.coverUrl"
              style="max-width: 624px; max-height: 351px"
              alt=""
            />
          </div>
          <div class="row body-card pb-3">
            <div class="col-lg-6 col-md-12 item">
              <span>ชื่อ</span>
              <span>{{ quest?.name ?? "-" }}</span>
            </div>
            <div class="col-lg-6 col-md-12 item">
              <span>รายละเอียด</span>
              <span>{{ quest?.details ?? "-" }}</span>
            </div>
          </div>
          <div class="row body-card pb-3">
            <div class="col-lg-6 col-md-12 item">
              <span>ประเภทรางวัล</span>
              <span>{{ displayRewardType(quest.rewardType) }}</span>
            </div>
            <div *ngIf="quest.rewardType === 'POINT'" class="col-lg-6 col-md-12 item">
              <span>คะแนน</span>
              <span>{{quest.rewardPoint}}</span>
            </div>
            <div *ngIf="quest.rewardType === 'ECOUPON_AND_POINT'" class="col-lg-6 col-md-12 pb3 item">
              <span>คะแนน</span>
              <span>{{quest.rewardPoint}}</span>
            </div>
            <div *ngIf="quest.rewardType === 'ECOUPON'" class="col-lg-6 col-md-12 item">
              <span>รางวัล</span>
              <span>{{ quest.ecouponName ?? '-' }}</span>
            </div>
          </div>
          <div class="row body-card pb-3">
            <div *ngIf="quest.rewardType === 'ECOUPON_AND_POINT'" class="col-lg-6 col-md-12 item">
              <span>รางวัล</span>
              <span>{{ quest.ecouponName ?? '-' }}</span>
            </div>
          </div>
          <div class="row body-card pb-3">
            <div class="col-lg-6 col-md-12 item">
              <span>Sub - เควส</span>
              <span>{{quest.totalSubquest + 1}}</span>
            </div>
            <div class="col-lg-6 col-md-12 item">
              <span>ช่วงเวลา</span>
              <span>{{ quest.startAt | date:'dd/MM/yyyy' }} - {{ quest.endAt | date:'dd/MM/yyyy' }}</span>
            </div>
          </div>
          <div class="row body-card pb-3">
            <div class="col-lg-6 col-md-12 item">
              <span>สถานะ</span>
              <div class="status">
                <div *ngIf="quest.status === 'ACTIVE'" class="status-active">Active</div>
                <div *ngIf="quest.status === 'INACTIVE'" class="status-inactive">Inactive</div>
              </div>
            </div>
          </div>
          <!-- subQuests -->
          <div class="container-sub">
            <div class="item-sub" *ngFor="let subQuest of quest.subQuests; let i = index"  [ngClass]="{'card-stamp' : subQuest.isSuccess}">
              <span class="title-pink pb-3">เงื่อนไข Sub - เควส {{i + 2}}</span>
              <div *ngIf="subQuest.periodTime != 'MORE_THAN_NOT_OVER'">
                <div class="row body-card">
                  <div class="col-lg-6 col-md-12 item pb-3">
                    <span>ช่วงเวลา</span>
                    <span>{{displayPeriodTime(subQuest.periodTime)}}</span>
                  </div>
                  <div class="col-lg-6 col-md-12 item pb-3">
                    <span>จำนวน (ตัวเลข)</span>
                    <span>{{subQuest.times}}</span>
                  </div>
                </div>
                <div class="row body-card">
                  <div class="col-lg-6 col-md-12 item pb-3">
                    <span>ประเภทวัน</span>
                    <span>{{displayPeriodType(subQuest.periodType)}}</span>
                  </div>
                  <div class="col-lg-6 col-md-12 item pb-3">
                    <span>ประเภทการใช้</span>
                    <span>{{getNameUseageType(subQuest.useType)}}</span>
                  </div>
                </div>
              </div>
              <div *ngIf="subQuest.periodTime == 'MORE_THAN_NOT_OVER'">
                <div class="row body-card">
                  <div class="col-lg-6 col-md-12 item pb-3">
                    <span>ช่วงเวลา</span>
                    <span>More than</span>
                  </div>
                </div>
                <div class="row body-card">
                  <div class="col-lg-6 col-md-12 item pb-3">
                    <span>จำนวน (ตัวเลข)</span>
                    <span>{{subQuest.times}}</span>
                  </div>
                  <div class="col-lg-6 col-md-12 item pb-3">
                    <span>ประเภทวัน</span>
                    <span>{{displayPeriodType(subQuest.periodType)}}</span>
                  </div>
                </div>
                <div class="row body-card">
                  <div class="col-lg-6 col-md-12 item pb-3">
                    <span>ช่วงเวลา</span>
                    <span>Not over</span>
                  </div>
                </div>
                <div class="row body-card">
                  <div class="col-lg-6 col-md-12 item pb-3">
                    <span>จำนวน (ตัวเลข)</span>
                    <span>{{subQuest.notOverTimes}}</span>
                  </div>
                  <div class="col-lg-6 col-md-12 item pb-3">
                    <span>ประเภทวัน</span>
                    <span>{{displayPeriodType(subQuest.notOverPeriodType)}}</span>
                  </div>
                </div>
                <div class="row body-card">
                  <div class="col-lg-6 col-md-12 item pb-3">
                    <span>ประเภทการใช้</span>
                    <span>{{getNameUseageType(subQuest.useType)}}</span>
                  </div>
                </div>
              </div>
              <img *ngIf="subQuest.isSuccess" class="stamp" src="./assets/images/stamp.png" alt="" height="100" width="100">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- campaign -->
    <!-- <div *ngIf="showResult && tab === 2" class="container-form">
      <div class="card py-3">
        <span class="title-card">{{ title }}</span>
        <div class="row body-card">
          <div class="col-lg-6 col-md-12 item">
            <span>Customer ID</span>
            <span>{{ customer?.id ?? "-" }}</span>
          </div>
          <div class="col-lg-6 col-md-12 item">
            <span>ชื่อลูกค้า</span>
            <span>{{ customer?.fullname ?? "-" }}</span>
          </div>
        </div>
        <div class="row body-card">
          <div class="col-lg-6 col-md-12 item">
            <span>อีเมล</span>
            <span>{{ customer?.email ?? "-" }}</span>
          </div>
          <div class="col-lg-6 col-md-12 item">
            <span>ชื่อ Line</span>
            <span>{{ customer?.lineName ?? "-" }}</span>
          </div>
        </div>
        <div class="content-card">
          <span class="title-blue">ข้อมูล คะแนน แคมเปญ</span>
          <div class="row body-card pb-2">
            <img
              [src]="campaign.coverUrl"
              style="max-width: 624px; max-height: 351px"
              alt=""
            />
          </div>
          <div class="row body-card py-3">
            <div class="col-lg-6 col-md-12 item">
              <span>ชื่อ</span>
              <span>{{ campaign?.name ?? "-" }}</span>
            </div>
            <div class="col-lg-6 col-md-12 item">
              <span>รายละเอียด</span>
              <span>{{ campaign?.detail ?? "-" }}</span>
            </div>
          </div>
          <div class="row body-card py-3">
            <div class="col-lg-6 col-md-12 item">
              <span>ช่วงเวลา</span>
              <span>{{ campaign?.startAt ? (campaign?.startAt | date:"dd/MM/yyyy") : '' }} - {{ campaign?.endAt ? (campaign?.endAt | date:"dd/MM/yyyy") : '' }}</span>
            </div>
            <div class="col-lg-6 col-md-12 item">
              <span>คะแนน</span>
              <span>{{campaign?.point ?? "-"}}</span>
            </div>
          </div>
          <div class="row body-card">
            <div class="col-lg-6 col-md-12 item">
              <span>สถานะ</span>
              <div class="status">
                <div *ngIf="campaign.status === 'ACTIVE'" class="status-active">Active</div>
                <div *ngIf="campaign.status === 'INACTIVE'" class="status-inactive">Inactive</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>

  <div class="d-flex justify-content-center mt-4 mb-4">
    <div class="center">
      <button *ngIf="!flowSuccess" class="btn btn-primary" (click)="submit()" [disabled]="disableBtnFlowUnSuccess">ยืนยัน</button>
      <button *ngIf="flowSuccess" class="btn btn-primary" (click)="submit()" disabled>ยืนยัน</button>
    </div>
  </div>
</div>

<div *ngIf="showScan" class="wrapper-scan">
  <div class="container-scan" (click)="clickIn($event)">
    <app-qr-code-scanner
      (callback)="callBackScan($event)"
    ></app-qr-code-scanner>
  </div>
</div>
